
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { useTranslation } from 'react-i18next';

interface AccountTypeBadgeProps {
  isLive: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * A standardized badge component to indicate whether an account is Live or Demo
 */
export function AccountTypeBadge({ isLive, className = '', size = 'md' }: AccountTypeBadgeProps) {
  const { t } = useTranslation();
  
  const sizeClasses = {
    sm: 'text-xs h-4',
    md: 'text-xs h-5',
    lg: 'text-sm h-6'
  };
  
  return (
    <Badge 
      variant="default"
      className={`${sizeClasses[size]} ${
        isLive 
          ? 'bg-green-500/20 text-green-700 border-green-500/30' 
          : 'bg-sky-500/20 text-sky-700 border-sky-500/30'
      } ${className}`}
    >
      {isLive ? t('live') : t('demo')}
    </Badge>
  );
}
